// 格式化时间

export function formatDateTime(date, fmt = 'YYYY-mm-dd HH:MM') {
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}

/**
 * base64转file对象
 * @return {[type]} [description]
 */
export function base64ToFileobj(dataurl) {
  let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
  while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
  }
  let theBlob = new Blob([u8arr], { type: mime });
  theBlob.lastModifiedDate = new Date();
  theBlob.name = 'file_'+(new Date()).getTime();
  return theBlob;
}

export function downloadFile (url, fileName) {
    if (!fileName) {
        fileName = url.substr(url.lastIndexOf('/')+1);
    }
    var x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = 'blob';
    x.onload=function() {
        var url = window.URL.createObjectURL(x.response)
        var a = document.createElement('a');
        a.href = url
        a.download = fileName;
        a.click()
    }
    x.send();
}

export function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

export function isGroupChat(chat) {
  return chat.type === "1";
}

/**
 * 毫秒转换友好的显示格式
 * 输出格式：21小时前
 * @param  {[type]} date 日期
 */
export function dateStr(date) {
  // 获取js 时间戳
  let time = new Date().getTime();
  // 去掉 js 时间戳后三位
  time = parseInt((time - date * 1000) / 1000);

  // 存储转换值
  let s;
  if (time < 60 * 10) {
    // 十分钟内
    return "刚刚";
  } else if (time < 60 * 60 && time >= 60 * 10) {
    // 超过十分钟少于1小时
    s = Math.floor(time / 60);
    return s + "分钟前";
  } else if (time < 60 * 60 * 24 && time >= 60 * 60) {
    // 超过1小时少于24小时
    s = Math.floor(time / 60 / 60);
    return s + "小时前";
  } else if (time < 60 * 60 * 24 * 3 && time >= 60 * 60 * 24) {
    // 超过1天少于3天内
    s = Math.floor(time / 60 / 60 / 24);
    return s + "天前";
  } else {
    // 超过3天
    let date = new Date(parseInt(date) * 1000);
    return (
      date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
    );
  }
}

export function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            if(typeof obj == 'object' && obj ){
                return true;
            }else{
                return false;
            }

        } catch(e) {
            return false;
        }
    }
}

export function getNewline(val, len) {
    let str = new String(val);
    let bytesCount = 0;
    let s = "";
    for (let i = 0, n = str.length; i < n; i++) {
        let c = str.charCodeAt(i);
        // 统计字符串的字符长度
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            bytesCount += 1;
        } else {
            bytesCount += 2;
        }
        // 换行
        s += str.charAt(i);
        if (bytesCount >= len) {
            s = s + '\n';
            // 重置
            bytesCount = 0;
        }
    }
    return s;
}

// function getVideoCover(videoUrl, callback) {
//   // 创建video元素
//   var video = document.createElement('video');
//   video.preload = 'metadata';
 
//   // 设置视频地址
//   video.src = videoUrl;
 
//   // 监听加载元数据完成事件
//   video.addEventListener('loadedmetadata', function() {
//     // 创建canvas元素
//     var canvas = document.createElement('canvas');
//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
 
//     // 绘制第一帧到canvas
//     var ctx = canvas.getContext('2d');
//     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
 
//     // 将canvas转换为base64图片
//     var imageUrl = canvas.toDataURL('image/png');
 
//     // 调用回调函数并传递图片地址
//     callback(imageUrl, video.videoWidth, video.videoHeight);
//   }, false);
// }

// lazada format
export function messageFormat(template_id, content) {
  content = JSON.parse(content);
  let msgContent = content;
  let contentTxt, lang;
  switch(template_id)
  {
    case 1:
      msgContent = content.txt;
    break;
    case 2:
      msgContent = content.txt;
    break;
    case 3:
      msgContent = '<div class="background-default" style="width:'+content.width*0.2+'px;height:'+content.height*0.2+'px;background-image: url(\''+content.imgUrl+'\');cursor: zoom-in; "></div>';
    break;
    // 表情
    case 4:
      msgContent = '<div class="background-default" title="'+content.txt+'" style="width:160px; height: 160px; background-image: url(\''+content.imgUrl+'\'"); "></div>';
    break;
    // 视频
    case 6:
      msgContent = '<div class="background-default" style="cursor:pointer; width:'+(content.width/10)+'px; height: '+(content.height/10)+'px; background-image: url(\''+content.imgUrl+'\'"); "></div>';
    break;
    // 商品卡片
    case 10006:
      msgContent = '';
      msgContent += '<div onclick="window.open(\''+content.actionUrl+'\')" class="card-product">'
      msgContent += '  <div class="card-header">Product Information</div>'
      msgContent += '  <div class="card-content">'
      msgContent += '    <div class="card-content-img" style="background-image: url(&quot;'+content.iconUrl+'&quot;);"></div>'
      msgContent += '    <div class="card-content-desc">'
      msgContent += '      <div class="card-content-desc-title">'+content.title+'</div>'
      msgContent += '      <div class="card-content-desc-price" title="'+content.price+'">'+content.price+'</div>'
      msgContent += '      <div class="card-content-desc-oldprice">'
      msgContent += '        <span class="card-content-desc-old" title="'+content.oldPrice+'">'+content.oldPrice+'</span>'
      msgContent += '        <span class="card-content-desc-discount">-'+content.discount+'%</span></div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
    // 订单卡片
    case 10007:
      msgContent = '';
      msgContent += '<div class="card-order">'
      msgContent += '  <div class="card-header">订单号#'+content.orderId+'</div>'
      msgContent += '  <div class="card-content">'
      msgContent += '    <div class="card-content-img" style="background-image: url(&quot;'+content.iconUrl+'&quot;);"></div>'
      msgContent += '    <div class="card-content-desc">'
      // msgContent += '      <div class="card-content-desc-title">'+content.productName+'</div>'
      msgContent += '      <div class="order-status">'+content.status+'</div>'
      msgContent += '      <div class="order-content">'+content.content+'</div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;

    // 优惠券卡片
    case 10008:
      msgContent = '';
      msgContent += '<div class="card-voucher">'
      msgContent += '  <div class="row top">'
      msgContent += '    <div class="voucher-type">'
      msgContent += '      <div class="background-default voucher-img" style="background-image: url(&quot;https://laz-img-cdn.alicdn.com/tfs/TB1rYq.n26TBKNjSZJiXXbKVFXa-128-128.jpg&quot;);"></div>'
      msgContent += '      <span class="type-name">'+(isJSON(content.voucherType) ? (JSON.parse(content.voucherType)).en : content.voucherType)+'</span></div>'
      msgContent += '    <div class="title text-two-lines">'+content.title+'</div>'
      msgContent += '    <div class="promotion">'
      msgContent += '      <div class="discount">'
      msgContent += '        <span class="amount">'+content.discountAmount+'</span>'
      msgContent += '        <span class="unit">'+content.currency+'</span></div>'
      msgContent += '      <div class="btn">เก็บ</div></div>'
      msgContent += '  </div>'
      msgContent += '  <div class="row bottom">'
      msgContent += '    <div class="period">'+content.period+'</div></div>'
      msgContent += '</div>'
    break;
    // 关注卡片
    case 10010:
      msgContent = '';
      msgContent += '<div class="card-follow">'
      msgContent += '  <div class="card-header">'+(JSON.parse(content.title)).en+'</div>'
      msgContent += '  <div class="card-content">'
      msgContent += '    <div class="background-default lzd-follow-img" style="background-image: url(&quot;'+content.iconUrl+'&quot;);"></div>'
      msgContent += '    <div class="lzd-follow-desc">'
      msgContent += '      <div class="lzd-follow-desc-text">'+content.desc+'</div></div>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
    // 退款卡片
    case 10011:
      msgContent = '';
      msgContent += '<div class="card-refund">'
      msgContent += '  <div class="card-header">'
      msgContent += '    <font style="vertical-align: inherit;">'
      msgContent += '      <font style="vertical-align: inherit;">退货要求</font></font>'
      msgContent += '  </div>'
      msgContent += '  <div class="card-content flex-column">'
      msgContent += '    <div class="lzd-refund-suborder">'
      msgContent += '      <div class="background-default card-img" style="background-image: url(&quot;'+content.subOrderIcon+'&quot;);"></div>'
      msgContent += '      <div class="desc">'
      msgContent += '        <div class="lzd-refund-suborder-title text-two-lines">'
      msgContent += '          <font style="vertical-align: inherit;">'
      msgContent += '            <font style="vertical-align: inherit;">'+content.subOrderTitle+'</font></font>'
      msgContent += '        </div>'
      msgContent += '        <div class="lzd-refund-suborder-desc">'
      msgContent += '          <span class="sku text-overflow">'+content.subOrderSKU+'</span>'
      msgContent += '          <span class="count text-overflow">'
      msgContent += '            <font style="vertical-align: inherit;">'
      msgContent += '              <font style="vertical-align: inherit;">×</font></font>'
      msgContent += '            <font style="vertical-align: inherit;">'
      msgContent += '              <font style="vertical-align: inherit;">'+content.subOrderCount+'</font></font>'
      msgContent += '          </span>'
      msgContent += '        </div>'
      msgContent += '      </div>'
      msgContent += '    </div>'
      msgContent += '    <div class="lzd-refund-suborder-total">'
      msgContent += '      <div class="background-default card-img visibility-hidden" style="background-image: url(&quot;https://th-live.slatic.net/p/66a840cae79f0d5b776af9470b8da15a.jpg&quot;);">'
      msgContent += '        <div class="mask">+0</div></div>'
      msgContent += '      <div class="lzd-suborder-total-desc">'
      msgContent += '        <div class="total-count">'
      msgContent += '          <font style="vertical-align: inherit;">'
      msgContent += '            <font style="vertical-align: inherit;">所有退货商品</font></font>'
      msgContent += '          <font style="vertical-align: inherit;">'
      msgContent += '            <font style="vertical-align: inherit;">：</font></font>'
      msgContent += '          <font style="vertical-align: inherit;">'
      msgContent += '            <font style="vertical-align: inherit;">'+content.orderTotalCount+'</font></font>'
      msgContent += '        </div>'
      msgContent += '        <div class="total-price text-overflow">'+content.orderTotalPrice+'</div></div>'
      msgContent += '    </div>'
      msgContent += '    <div class="lzd-refund-order-desc">'
      msgContent += '      <div>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">订购</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">：</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">'+content.refundOrderId+'</font></font>'
      msgContent += '      </div>'
      msgContent += '      <div>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">订购日期</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">：</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">'+content.refundOrderDate+'</font></font>'
      msgContent += '      </div>'
      msgContent += '      <div>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">退货原因</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">：</font></font>'
      msgContent += '        <font style="vertical-align: inherit;">'
      msgContent += '          <font style="vertical-align: inherit;">'+content.refundOrderReason+'</font></font>'
      msgContent += '      </div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '  <div class="card-footer right">'
      msgContent += '    <button class="simple-button btn ripple ">'
      msgContent += '      <font style="vertical-align: inherit;">'
      msgContent += '        <font style="vertical-align: inherit;">查看更多</font></font>'
      msgContent += '    </button>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
    case 200014:
    console.log(content.products)
      msgContent = '';
      msgContent += '<div class="card-invite-order">'
      msgContent += '  <div class="next-box im-ui-header" style="flex-flow: row; align-items: center;">'
      msgContent += '    <div class="im-ui-bargain-icon" style="margin: 0px 1.5px 0px 0px;">'
      msgContent += '      <img src="https://lzd-img-global.slatic.net/g/tps/imgextra/i4/O1CN01WK6uOw27DVTVDElwm_!!6000000007763-55-tps-13-13.svg"'
      msgContent += '      alt="">'
      msgContent += '    </div>'
      msgContent += '    <div class="im-ui-header-title" style="margin: 0px 0px 0px 1.5px;">'
      msgContent += '      [砍价申请] 砍价申请待处理'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '  <div class="next-box im-ui-bargain-content" style="flex-flow: column;">'
      msgContent += '    <div class="next-box im-ui-content-product" style="flex-flow: row; justify-content: space-between; margin: 0px;">'
      for (var i=0; i<content.products.length; i++) {
        console.log(content.products[i])
        msgContent += '      <div class="next-box" style="flex-flow: row;">'
        msgContent += '        <img src="'+content.products[i].imgUrl+'"'
        msgContent += '        class="im-ui-pro-img" style="margin: 0px 5px 0px 0px;">'
        msgContent += '        <div class="next-box" style="flex-flow: column; margin: 0px 0px 0px 5px;">'
        msgContent += '          <div class="im-ui-content-item-name" style="margin: 0px 0px 2px;">'
        msgContent += '            '+content.products[i].title+''
        msgContent += '          </div>'
        msgContent += '          <div class="im-ui-content-item-attribute" style="margin: 2px 0px;">'
        msgContent += '            '+content.products[i].saleProperty+''
        msgContent += '          </div>'
        msgContent += '          <div class="next-box" style="flex-flow: row; justify-content: space-between; align-items: center; margin: 2px 0px 0px;">'
        msgContent += '            <div class="im-ui-content-price">'
        msgContent += '              '+content.products[i].price+''
        msgContent += '            </div>'
        msgContent += '            <div class="im-ui-content-total">'
        msgContent += '              数量: '+content.products[i].total+''
        msgContent += '            </div>'
        msgContent += '          </div>'
        msgContent += '        </div>'
      }

      msgContent += '      </div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '  <div class="next-box im-ui-bargain-voucher" style="flex-flow: row; justify-content: space-between; align-items: center;">'
      msgContent += '    <div class="next-box" style="flex-flow: row; align-items: center; font-weight: 500; font-size: 14px; color: rgb(0, 0, 0);">'
      msgContent += '      <span class="help-tip has-help">'
      msgContent += '        优惠券'
      msgContent += '        <i class="next-icon next-icon-prompt next-xs help-tip-icon">'
      msgContent += '        </i>'
      msgContent += '      </span>'
      msgContent += '    </div>'
      msgContent += '    <div class="next-box im-ui-invite-voucher-price" style="flex-flow: column;">'
      msgContent += '      -'+content.currency+''+content.offerDiscount+''
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '  <div class="next-box im-ui-bottom" style="flex-flow: row; justify-content: space-between; align-items: center; border-bottom: 1px solid rgb(238, 238, 238);">'
      msgContent += '    <div class="title">'
      msgContent += '      券后价'
      msgContent += '    </div>'
      msgContent += '    <div class="next-box" style="flex-flow: row; justify-content: flex-end; align-items: center;">'
      msgContent += '      <div class="totalPrice" style="margin: 0px 2.5px 0px 0px;">'
      msgContent += '        '+content.currency+''+content.originalAmount+''
      msgContent += '      </div>'
      msgContent += '      <div class="price" style="margin: 0px 0px 0px 2.5px; font-weight: bold;">'
      msgContent += '        '+content.currency+''+content.offerAmount+''
      msgContent += '      </div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '  <div class="next-box im-ui-bargain-btn" style="flex-flow: row; justify-content: flex-end; align-items: center;">'
      msgContent += '    <button data-spm="d_bargain_deny_92c33DnkgHS0BKTBB28791" type="button"'
      msgContent += '    class="next-btn next-medium next-btn-secondary aplus-auto-exp" data-aplus-ae="x79_77c834e2"'
      msgContent += '    data-spm-anchor-id="a1zawg.26850391.im_message_panel.d_bargain_deny_92c33DnkgHS0BKTBB28791.136c4edfRTpDRd"'
      msgContent += '    data-aplus-clk="x79_3ec8cc34" style="margin: 0px 4px 0px 0px;">'
      msgContent += '      <span class="next-btn-helper">'
      msgContent += '        拒绝'
      msgContent += '      </span>'
      msgContent += '    </button>'
      msgContent += '    <button data-spm="d_bargain_agree_92c33DnkgHS0BKTBB28791" type="button"'
      msgContent += '    class="next-btn next-medium next-btn-primary aplus-auto-exp" data-aplus-ae="x80_39206d0a"'
      msgContent += '    data-spm-anchor-id="a1zawg.26850391.im_message_panel.d_bargain_agree_92c33DnkgHS0BKTBB28791.136c4edfRTpDRd"'
      msgContent += '    data-aplus-clk="x80_6e3d62a1" style="margin: 0px 0px 0px 4px;">'
      msgContent += '      <span class="next-btn-helper">'
      msgContent += '        接受'
      msgContent += '      </span>'
      msgContent += '    </button>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
    // 自动回复
    case 10015:
      var messageText = "";
      if (content.txt) {
        try {
          contentTxt = JSON.parse(content.txt);
          lang = '';
          for (let k in contentTxt) {
            if (lang == '') {lang = k;}
          }
          messageText = contentTxt[lang]
        } catch (e) {
          messageText = content.txt;
        }
      }
      msgContent = '';
      msgContent += '<div class="card-action">'
      msgContent += '  <div class="message-text-box">'
      msgContent += '    <div class="im-ui-message-text" data-spm-anchor-id="a1zawg.26850391.im_message_panel.i1.1dc14edfLFeLnq">'+messageText+'</div>'
      msgContent += '    <div class="im-ui-message-actions">'
      for (let i=1; i<=content.actionSize; i++) {      
        let actionText = content['action'+i+'Txt'];
        msgContent += '      <div class="action-item" data-spm-anchor-id="a1zawg.26850391.im_message_panel.i2.1dc14edfLFeLnq">'
        msgContent += '        <a class="action-link">'+actionText+'</a>'
        msgContent += '      </div>'
      }
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
  }
  
  return msgContent; 

}

// shopee format
export function messageFormat2(template_id, content) {
  let msgContent = '';
  switch(template_id) 
  {
    case 'notification':
    // 系统消息
    msgContent = content.notification_for_sender;
    break;
    case 'text':
    // 文本
    if (content.image_url) {
       msgContent = '<div class="background-default" title="" style="width:160px; height: 160px; background-image: url(\''+content.image_url+'\'"); "></div>';
    } else {
      msgContent = content.text;
    }
    break;
    case 'sticker':
    // 表情
    if (content.image_url) {
       msgContent = '<div class="background-default" title="" style="width:160px; height: 160px; background-image: url(\''+content.image_url+'\'"); "></div>';
    } else {
      for (let i=0; i<faceUtils2.alt.length; i++) {
        for (let j=0; j<faceUtils2.alt[i].chilrens.length; j++) {
          let face = faceUtils2.alt[i].chilrens[j];
          if (face.sticker_id != content.sticker_id) continue;
          if (face.sticker_package_id == content.sticker_package_id) {
            msgContent = '<div class="background-default" title="'+face.label+'" style="width:160px; height: 160px; background-image: url(\''+face.img+'\'"); "></div>';
            continue;
          }
        }
      }
    }
    break;
    case 'image':
    msgContent = '<div class="background-default" style="width:'+(content.thumb_width > 0 ? content.thumb_width*0.5+'px' : '100px')+';height:'+(content.thumb_height > 0 ? content.thumb_height*0.5+'px' : '100px')+';background-image: url(\''+content.url+'\');cursor: zoom-in; "></div>';
    break;
    case 'image_with_text':
    msgContent = '<div style="padding-bottom: 5px;" class="image_with_text">'
    msgContent += '<img src="'+content.image_url+'" style="width:'+(content.thumb_width > 0 ? content.thumb_width*0.5+'px' : '100px')+';height:'+(content.thumb_height > 0 ? content.thumb_height*0.5+'px' : '100px')+';cursor: zoom-in; "/>';
    msgContent += '<p><a href="'+(content.link_url ? content.link_url : 'javascript:void(0);')+'">'+content.text+'</a></p>';
    msgContent += '</div>';
    break;
    case 'item':
    // 商品
    msgContent = '';
    msgContent += '<div onclick="window.open(\''+'{{actionUrl}}'+'\')" class="card-product">'
    msgContent += '  <div class="card-header">Product Information</div>'
    msgContent += '  <div class="card-content">'
    msgContent += '    <div class="card-content-img" style="background-image: url(&quot;'+'{{iconUrl}}'+'&quot;);"></div>'
    msgContent += '    <div class="card-content-desc">'
    msgContent += '      <div class="card-content-desc-title">'+'{{title}}'+'</div>'
    msgContent += '      <div class="card-content-desc-price" title="'+'{{price}}'+'">'+'{{price}}'+'</div>'
    msgContent += '      <div class="card-content-desc-oldprice">'
    msgContent += '        <span class="card-content-desc-old" title="'+'{{oldPrice}}'+'">'+'{{oldPrice}}'+'</span>'
    msgContent += '        <span class="card-content-desc-discount">-'+'{{discount}}'+'%</span></div>'
    msgContent += '    </div>'
    msgContent += '  </div>'
    msgContent += '</div>'

    break;
    // 订单卡片
    case 'order':
      msgContent = '';
      msgContent += '<div class="card-order">'
      msgContent += '  <div class="card-header">订单号#'+'{{orderId}}'+'</div>'
      msgContent += '  <div class="card-content">'
      msgContent += '    <div class="card-content-img" style="background-image: url(&quot;'+'{{iconUrl}}'+'&quot;);"></div>'
      msgContent += '    <div class="card-content-desc">'
      msgContent += '      <div class="card-content-desc-title">'+'{{productName}}'+'</div>'
      msgContent += '      <div class="order-status">'+'{{status}}'+'</div>'
      msgContent += '      <div class="order-content">'+'{{content}}'+'</div>'
      msgContent += '    </div>'
      msgContent += '  </div>'
      msgContent += '</div>'
    break;
    case 'offer':
    // 商品
    msgContent = '';
    msgContent += '<div class="card-product">'
    msgContent += '  <div class="card-header">OFFER</div>'
    msgContent += '  <div class="card-content">'
    msgContent += '    <div class="card-content-img" style="background-image: url(&quot;'+'{{image}}'+'&quot;);"></div>'
    msgContent += '    <div class="card-content-desc">'
    msgContent += '      <div class="card-content-desc-title">'+'{{itemName}}'+'</div>'
    msgContent += '      <div class="card-content-desc-price" >Offer Price: '+'{{offerPrice}}'+'</div>'
    msgContent += '      <div class="card-content-desc-quantity">Quantity: '+'{{quantity}}'+'</div>'
    msgContent += '      <div class="card-content-desc-quantity">Total Price: '+'{{totalPrice}}'+'</div>'
    msgContent += '  </div>'
    msgContent += '</div>'
    break;
    // 视频
    case 'video':
      msgContent = '<div class="background-default" style="cursor: pointer; width:200px; height: 100px; background-image: url('+require('../static/img/video_cover.png')+'); "></div>';

    break;

  }
  return msgContent;
}


export function sendMsgFormat(msg) {
  let content = {};
  switch(msg.template_id) {
    // 文本
    case 1:
      content = {"txt": msg.data.txt};
    break;
    case 3:
      content = {"imgUrl": msg.data.imgUrl, "width": msg.data.width, "height": msg.data.height};
    break;
    case 6:
      content = {"imgUrl": msg.data.imgUrl, "width": msg.data.width, "height": msg.data.height, "videoId": msg.data.videoId};
    break;
    case 4:
      content = {"txt": msg.data.txt, "imgUrl": msg.data.imgUrl};
    break;
    case 10010:
      content = {"title": msg.data.title, "iconUrl": msg.data.iconUrl, "desc": msg.data.desc};
    break;
    case 10006:
      content = {"title": msg.data.title, "price": msg.data.price, "oldPrice": msg.data.oldPrice, "discount": msg.data.discount, "iconUrl": msg.data.iconUrl, "itemId": msg.data.itemId, "actionUrl": msg.data.actionUrl};
    break;
    case 10007:
      content = {"orderId": msg.data.orderId, "iconUrl": msg.data.iconUrl, "content": msg.data.content, "status": msg.data.status, "productName": msg.data.productName};
    break;
    case 10008:
      content = msg.data;
    break;
  }
  return JSON.stringify(content);
}

export function scrollBottom(self, Selector) {
  self.$nextTick(() => {
    
    Selector.lastChild.scrollIntoView({
      behavior: "auto",
      block: "end",
      inline: "nearest",
    });

  });
}

/**
 * 聊天会话
 */
export class Chat {
  constructor(id, name, avatar, unReadCount, lastMessage, mobile, email, type) {
    this.id = id;
    this.name = name;
    this.avatar = avatar;
    this.unReadCount = unReadCount;
    this.lastMessage = lastMessage;
    this.mobile = mobile;
    this.email = email;
    this.type = type;
  }
}

/**
 * 图片加载完成处理函数
 * @param arr 图片的src集合
 * @returns {Promise}
 */
// function preloadImages(arr) {
//   let loadedImage = 0;
//   let images = [];
//   return new Promise(function(resolve, reject) {
//     for (let i = 0; i < arr.length; i++) {
//       images[i] = new Image();
//       images[i].src = arr[i];
//       images[i].onload = function() {
//         loadedImage++;
//         if (loadedImage === arr.length) {
//           resolve();
//         }
//       };
//       images[i].onerror = function() {
//         reject();
//       };
//     }
//   });
// }

/**
 * 图片加载完成，聊天对话框scroll拉到最下
 * @param id 容器id
 */
export function imageLoad(id) {
  console.log(id);

  // let messageBox = document.getElementById('message-box');
  // messageBox = messageBox.querySelector(id);
  // console.log(messageBox);
  // if (messageBox) {
  //   let images = messageBox.getElementsByTagName("img");
  //   if (images) {
  //     let arr = [];
  //     for (let i = 0; i < images.length; i++) {
  //       arr[i] = images[i].src;
  //     }
  //     preloadImages(arr)
  //       .then(() => {
  //         scrollBottom(id);
  //       })
  //       .catch(function() {
  //         scrollBottom(id);
  //       });
  //   }
  // }
}

export let faceUtils = {
  alt: [
    {
      'icon': require('../static/img/face/tab01.png'),
      'chilrens': [
        {'label': '[happy]', 'icon': './static/img/face/tab01-happy.png', 'img': 'https://sg-live.slatic.net/original/0e048d1c6d42835cdc386241b2a855c8.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/30ff084a270eae973a02ec74e216ba51.png'},
        {'label': '[veryhappy]', 'icon':'./static/img/face/tab01-veryhappy.png', 'img': 'https://sg-live.slatic.net/original/bc42a3eff1a2ea9cda78e70ba85ca600.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/bfc697859931b2257f956680bff82a47.png'},
        {'label': '[laughing]', 'icon':'./static/img/face/tab01-laughing.png', 'img': 'https://sg-live.slatic.net/original/d66d57245a5a53bfce17c7ee9f305dea.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/0bbb09ff7d823c4566044b615c0c214c.png'},
        {'label': '[smirking]', 'icon':'./static/img/face/tab01-smirking.png', 'img': 'https://sg-live.slatic.net/original/35f56b5e6b4cb8cd7ece01a486990758.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/f62c5bdb92d703450d58733928a5e08e.png'},
        {'label': '[inlove]', 'icon':'./static/img/face/tab01-inlove.png', 'img': 'https://sg-live.slatic.net/original/c1af284b49ca2855b6250da001eb86ff.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/87b1950d4a6f7e02d08065f2d2e9189c.png'},
        {'label': '[thumbsup]', 'icon':'./static/img/face/tab01-thumbsup.png', 'img': 'https://sg-live.slatic.net/original/41bbcbce0b13176ad4cfa9781a935f30.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/f82b6725f3618cb4e9a90a35d043a75f.png'},
        {'label': '[surprised]', 'icon': './static/img/face/tab01-surprised.png', 'img': 'https://sg-live.slatic.net/original/ed3e32239214313a5f88b7f5522e8009.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/81272c3b99b9ae6b719647ec68ab222d.png'},
        {'label': '[shocked]', 'icon':'./static/img/face/tab01-shocked.png', 'img': 'https://sg-live.slatic.net/original/e795a481618af187f6b7df0f68feb527.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/b96d057d60b5d4df9471f6d021b10830.png'},
        {'label': '[sad]', 'icon':'./static/img/face/tab01-sad.png', 'img': 'https://sg-live.slatic.net/original/1ba2df5142564a44966551027b9c6bbc.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/a17e7b66e101f6eafff7ea27f63f31e6.png'},
        {'label': '[crying]', 'icon': './static/img/face/tab01-crying.png', 'img': 'https://sg-live.slatic.net/original/6c7e93fd7740f72bfbccff77504a30d9.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/b37b721709875f5c4e245cf331da2987.png'},
        {'label': '[confused]', 'icon': './static/img/face/tab01-confused.png', 'img': 'https://sg-live.slatic.net/original/1eca1d0994cb93f2df2408ffa749c18d.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/2e13c266a9e7fdd4d2a840e2a1939dd9.png'},
        {'label': '[shy]', 'icon':'./static/img/face/tab01-shy.png', 'img': 'https://sg-live.slatic.net/original/cc2b0c1db5ae9014de532155fb114a3e.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/5986d2f2c30c09a981bf971485285aeb.png'},
        {'label': '[angry]', 'icon':'./static/img/face/tab01-angry.png', 'img': 'https://sg-live.slatic.net/original/3825aa88b59a9209053655fede4d1131.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/633bee4754d1e298dbf3a38053c75dd5.png'},
        {'label': '[disgust]', 'icon':'./static/img/face/tab01-disgust.png', 'img': 'https://sg-live.slatic.net/original/5b23d7bee1985418de4a084e72c16e47.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/e398d006343bfdf2efd665ac726604b3.png'},
        {'label': '[heart]', 'icon':'./static/img/face/tab01-heart.png', 'img': 'https://sg-live.slatic.net/original/9715a92a20bc87a07988eb4825bf15ca.png', 'smallImgUrl': 'https://sg-live.slatic.net/original/012b57eeed968cf2787cd944ab733427.png'},
      ]
    },
    {
      'icon': require('../static/img/face/tab02.png'),
      'chilrens': [
        {'label': '[thank you]', 'icon': './static/img/face/tab02-thank_you.png', 'img': 'https://sg-live.slatic.net/other/im/ac34173dd76c7b099064aa0859d9aeb8.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/55db78f572521414ef5b98c1dfddf63f.png'},
        {'label': '[cheer up]', 'icon':'./static/img/face/tab02-cheer_up.png', 'img': 'https://sg-live.slatic.net/other/im/901116c5359491b3bfe57fdb299f893f.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/5e917d78922de317df3a25c2a3c13aa6.png'},
        {'label': '[red pocket]', 'icon':'./static/img/face/tab02-red_pocket.png', 'img': 'https://sg-live.slatic.net/other/im/2ef57a7e72c344f5347da78efc704451.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/72c2d2a7da6b3481c9c19fe62fb17a3d.png'},
        {'label': '[yummy]', 'icon':'./static/img/face/tab02-yummy.png', 'img': 'https://sg-live.slatic.net/other/im/122730d703f7ca3b27c73a97788eef9a.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/cb9f07cb5c7f6801ea1ce830d3397bd4.png'},
        {'label': '[dance]', 'icon':'./static/img/face/tab02-dance.png', 'img': 'https://sg-live.slatic.net/other/im/a87ad57918b0d593fbd97381afcbe5cf.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/c90c72a4a3f2fd71514cde42ee91a6bb.png'},
        {'label': '[bye]', 'icon':'./static/img/face/tab02-bye.png', 'img': 'https://sg-live.slatic.net/other/im/2a693f4624ae1491d6ba5743fd8a3ee9.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/94cbeb5083a622e4d400e489371bbc14.png'},
        {'label': '[gift]', 'icon': './static/img/face/tab02-gift.png', 'img': 'https://sg-live.slatic.net/other/im/d9155fd8aff7b428d17c47d5fd8e9642.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/36d49a2e1eb206160f7de6a4d1000e73.png'},
        {'label': '[thirsty]', 'icon':'./static/img/face/tab02-thirsty.png', 'img': 'https://sg-live.slatic.net/other/im/c999fa373bab823d8c3f1256d0e810cd.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/6eaa18380e90d049228221d6425f8a7d.png'},
        {'label': '[sleepy]', 'icon':'./static/img/face/tab02-sleepy.png', 'img':'https://sg-live.slatic.net/other/im/8cef0edb766d587e2cfd29c67e6a48e4.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/a278243d7012ae9bef524c11fc56ded6.png'},
        {'label': '[fountain]', 'icon': './static/img/face/tab02-fountain.png', 'img':'https://sg-live.slatic.net/other/im/3d09b64b8fb3599e11f38602a080fc3e.gif', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/ee2d4cacb05ae9b26f56052d9bd782cc.png'},
      ]
    },
    {
      'icon': require('../static/img/face/tab03.png'),
      'chilrens': [
        {'label': '[Lazzie yeah]', 'icon': './static/img/face/tab03-Lazzie_yeah.png', 'img': 'https://sg-live.slatic.net/other/im/f4ed96d29cbd41f16c30ec712c5cd9db.png', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/f4ed96d29cbd41f16c30ec712c5cd9db.png'},
        {'label': '[Lazzie gift]', 'icon':'./static/img/face/tab03-Lazzie_gift.png', 'img': 'https://sg-live.slatic.net/other/im/9f13596921fa5b2000a8266b557018a9.png', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/b079af4db32da2e90ef8e394018958f3.png'},
        {'label': '[Lazzie heart]', 'icon':'./static/img/face/tab03-Lazzie_heart.png', 'img': 'https://sg-live.slatic.net/other/im/b8fb565cb055897c3029b7cd011c9a6b.png', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/dfb9e3ffcb5f9ee243276d4ad33eeb57.png'},
        {'label': '[Christmas]', 'icon':'./static/img/face/tab03-Christmas.png', 'img': 'https://sg-live.slatic.net/other/im/1461eb044cbe81614582a83e8efa7bf7.png', 'smallImgUrl': 'https://sg-live.slatic.net/other/im/ca0af297239dd70e507fbd80ccc28f84.png'},
      ]
    },
  ],
  faces: function() {
    let self = this;
    let arr = {};
    for (let i = 0; i < self.alt.length; i++) {
      arr[self.alt[i]] = "./static/face/" + i + ".gif";
    }
    return arr;
  }
};

export let faceUtils2 = {
  alt: [
    {
      'icon': require('../static/img/shopee/face/shopee_9thb.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0010.png'), 'sticker_id': '00010', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0011.png'), 'sticker_id': '00011', 'sticker_package_id': 'shopee_9thb'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shopee_9thb_0012.png'), 'sticker_id': '00012', 'sticker_package_id': 'shopee_9thb'},
      ]
    },
    {
      'icon': require('../static/img/shopee/face/shogi_2021_pack_4.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shogi_2021_pack_4'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_4_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shogi_2021_pack_4'},

      ]
    },
    {
      'icon': require('../static/img/shopee/face/shogi_2021_pack_3.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shogi_2021_pack_3'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_3_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shogi_2021_pack_3'},

      ]
    },
    {
      'icon': require('../static/img/shopee/face/shogi_2021_pack_2.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shogi_2021_pack_2'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shogi_2021_pack_2'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_2_0010.png'), 'sticker_id': '00010', 'sticker_package_id': 'shogi_2021_pack_2'},

      ]
    },
    {
      'icon': require('../static/img/shopee/face/shogi_2021_pack_1.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shogi_2021_pack_1'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shogi_2021_pack_1'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0010.png'), 'sticker_id': '00010', 'sticker_package_id': 'shogi_2021_pack_1'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shogi_2021_pack_1_0011.png'), 'sticker_id': '00011', 'sticker_package_id': 'shogi_2021_pack_1'},

      ]
    },
    {
      'icon': require('../static/img/shopee/face/shrimp_th_new.png'),
      'chilrens': [
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0001.png'), 'sticker_id': '0001', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0002.png'), 'sticker_id': '0002', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0003.png'), 'sticker_id': '0003', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0004.png'), 'sticker_id': '0004', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0005.png'), 'sticker_id': '0005', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0006.png'), 'sticker_id': '0006', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0007.png'), 'sticker_id': '0007', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0008.png'), 'sticker_id': '0008', 'sticker_package_id': 'shrimp_th_new'},
        {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_0009.png'), 'sticker_id': '0009', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00010.png'), 'sticker_id': '00010', 'sticker_package_id': 'shrimp_th_new'},

        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00011.png'), 'sticker_id': '00011', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00012.png'), 'sticker_id': '00012', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00013.png'), 'sticker_id': '00013', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00014.png'), 'sticker_id': '00014', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00015.png'), 'sticker_id': '00015', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00016.png'), 'sticker_id': '00016', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00017.png'), 'sticker_id': '00017', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00018.png'), 'sticker_id': '00018', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00019.png'), 'sticker_id': '00019', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00020.png'), 'sticker_id': '00020', 'sticker_package_id': 'shrimp_th_new'},

        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00021.png'), 'sticker_id': '00021', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00022.png'), 'sticker_id': '00022', 'sticker_package_id': 'shrimp_th_new'},
        // {'label': '[happy]', 'img': require('../static/img/shopee/face/shrimp_th_new_00023.png'), 'sticker_id': '00023', 'sticker_package_id': 'shrimp_th_new'},

      ]
    },
    
  ]
};

export function transform(content) {
  // 支持的html标签
  let html = function(end) {
    return new RegExp(
      "\\n*\\[" +
        (end || "") +
        "(code|pre|div|span|p|table|thead|th|tbody|tr|td|ul|li|ol|li|dl|dt|dd|h2|h3|h4|h5)([\\s\\S]*?)]\\n*",
      "g"
    );
  };
  let fa = faceUtils.faces();
  if (content) {
    content = content
      .replace(/&(?!#?[a-zA-Z0-9]+;)/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/'/g, "&#39;")
      .replace(/"/g, "&quot;") // XSS
      .replace(/@(\S+)(\s+?|$)/g, '@<a href="javascript:;">$1</a>$2')

      .replace(/face\[([^\s\\[\]]+?)]/g, function(face) {
        // 转义表情
        let alt = face.replace(/^face/g, "");
        return (
          '<img alt="' +
          fa[alt] +
          '" title="' +
          fa[alt] +
          '" src="' +
          fa[alt] +
          '">'
        );
      })
      .replace(/img\[([^\s]+?)]/g, function(img) {
        // 转义图片
        let href = img.replace(/(^img\[)|(]$)/g, "");
        return (
          '<img class="message-img" src="' + href + '" alt="消息图片不能加载">'
        );
      })
      .replace(/file\([\s\S]+?\)\[[\s\S]*?]/g, function(str) {
        // 转义文件
        let href = (str.match(/file\(([\s\S]+?)\)\[/) || [])[1];
        let text = (str.match(/\)\[([\s\S]*?)]/) || [])[1];
        if (!href) return str;
        return (
          '<a class="message-file" href="' +
          href +
          '"><i class="ivu-icon ivu-icon-md-arrow-down"></i>' +
          (text || href) +
          "</a>"
        );
      })
      .replace(/audio\[([^\s]+?)]/g, function(audio) {
        // 转义音频
        return (
          '<div class="message-audio" data-src="' +
          audio.replace(/(^audio\[)|(]$)/g, "") +
          '"><i class="layui-icon">&#xe652;</i><p>音频消息</p></div>'
        );
      })
      .replace(/video\[([^\s]+?)]/g, function(video) {
        // 转义音频
        return (
          '<div class="message-video"  data-src="' +
          video.replace(/(^video\[)|(]$)/g, "") +
          '"><i class="layui-icon">&#xe652;</i></div>'
        );
      })
      .replace(/a\([\s\S]+?\)\[[\s\S]*?]/g, function(str) {
        // 转义链接
        let href = (str.match(/a\(([\s\S]+?)\)\[/) || [])[1];
        let text = (str.match(/\)\[([\s\S]*?)]/) || [])[1];
        if (!href) return str;
        return (
          '<a href="' + href + '" target="_blank">' + (text || href) + "</a>"
        );
      })
      .replace(html(), "<$1 $2>")
      .replace(html("/"), "</$1>") // 转移HTML代码
      .replace(/\n/g, "<br>"); // 转义换行
  }
  return content;
}

export const ChatListUtils = {
  listKey: "_chatList",
  setChatList: function(userId, chatList) {
    localStorage.setItem(userId + this.listKey, JSON.stringify(chatList));
  },
  //从缓存中获取已经保存的会话
  getChatList: function(userId) {
    let str = localStorage.getItem(userId + this.listKey);
    if (!str) {
      return [];
    }
    console.log("getChatList", str);
    return JSON.parse(str);
  },
  //删除聊天会话框
  delChat: function(userId, chat) {
    let tempChatList = [];
    for (let item of this.getChatList(userId)) {
      if (String(item.id) !== String(chat.id)) {
        tempChatList.push(item);
      }
    }
    // 放入缓存
    this.setChatList(userId, tempChatList);
    return tempChatList;
  },
  /**
   * 刷新会话列表
   * @param self 当前对象
   * @param user 用户
   * @param host 主机名
   * @param type 0 单聊 1 群聊
   * @returns {Chat} 当前会话
   */
  resetChatList: function(self, user, host, type) {
    let chatList = this.getChatList(self.$store.state.user.id);
    // 删除当前用户已经有的会话
    let newChatList = chatList.filter(function(element) {
      return String(element.id) !== String(user.id);
    });

    let avatar = user.avatar;
    if (user.avatar.indexOf(host) === 0) {
      avatar = user.avatar;
    } else {
      avatar = host + user.avatar;
    }
    // 重新添加会话，放到第一个
    let chat = new Chat(
      user.id,
      user.name,
      avatar,
      0,
      "",
      user.mobile,
      user.email,
      type
    );
    newChatList.unshift(chat);
    // 存储到localStorage 的 chatList
    this.setChatList(self.$store.state.user.id, chatList);
    self.$store.commit("setChatList", newChatList);
    return chat;
  }
};
//信息的类型 MSG_PING 心跳 、MSG_READY 链接就绪  MSG_MESSAGE 消息
export const MessageInfoType = {
  MSG_PING: "ping",
  MSG_READY: "1",
  MSG_MESSAGE: "2"
};

/**
 * 退出登录
 * @param self vue this对象
 */
export function logout(self) {
  self.$store.commit("closeConnect");
  self.$store.commit("clear");
  self.$store.commit("clearFlushTokenTimerId");
  self.$router.push({
    path: "/",
    params: {}
  });
}

export const ErrorType = {
  TIMEOUT_ERROR: 9, //超时
  TOKEN_ERROR: 401, //token 失效错误
  PARAM_ERROR: 400, //参数错误
  FLUSH_TOKEN_ERROR: 7, //刷新token错误
  SERVER_ERROR: 500, //服务器错误
  NET_ERROR: "TypeError: Failed to fetch" //网络链接不通
};
